import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import { Container, Row, Col, Card, Badge, Button } from "react-bootstrap";
import axios from "axios";
import moment from "moment";
import Comment from "./Comment";
const styles = {
  card: {
    borderRadius: 10,
    overflow: "hidden",
    border: "1.5px solid #c6deca",
    boxShadow: "0 2px 10px rgba(20,50,30,0.06)",
  },
  commentsCardHeader: {
    backgroundColor: "#1a3328",
    color: "#ffffff",
    borderRadius: "10px 10px 0 0",
    padding: "0.85rem 1.25rem",
  },
  badgePill: {
    marginLeft: "0.4rem",
    backgroundColor: "rgba(255,255,255,0.18)",
    color: "#ffffff",
    fontSize: "0.72rem",
    fontWeight: 700,
  },
  commentsCardBody: {
    maxHeight: "30rem",
    overflowY: "scroll",
    margin: "0px",
    padding: "0px",
  },
};

const IssueComments = (props) => {
  const [issueComments, setIssueComments] = useState([]);

  useEffect(() => {
    setIssueComments(props.issueDetails.comments);
    console.log("From IssueComments----------------->", props.issueDetails);
  }, [props]);

  const popComment = (comment) => {
    var t = JSON.parse(JSON.stringify(issueComments));
    t.shift();
    setIssueComments(t);
  };

  const saveComment = (comment) => {
    comment["issueID"] = props.issueDetails._id;
    if (comment["commentByName"]) {
      delete comment["commentByName"];
    }
    console.log(comment);
    if (comment._id) {
      //edit flow
      axios.post(`${process.env.REACT_APP_API_URL}/api/comment/editComment`, comment).then(
        (res) => {
          if (res.status === 200) {
            console.log("Comment edited successfully");
            props.reloadData();
          } else {
            console.log(res);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    } else {
      axios.post(`${process.env.REACT_APP_API_URL}/api/comment/addComment`, comment).then(
        (res) => {
          if (res.status === 200) {
            console.log("Comment added successfully");
            props.reloadData();
          } else {
            console.log(res);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  };
  useEffect(() => {
    console.log("Issue Comments Rerendered");
  }, [issueComments]);
  return (
    <Card style={styles.card}>
      <Card.Header style={styles.commentsCardHeader}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <span style={{ fontWeight: 700, fontSize: "0.85rem", letterSpacing: "0.06em", textTransform: "uppercase", color: "#fff" }}>
              Comments
            </span>
            <span style={{ fontSize: "0.72rem", fontWeight: 700, padding: "2px 9px", borderRadius: 8, backgroundColor: "rgba(255,255,255,0.18)", color: "#fff" }}>
              {issueComments ? issueComments.length : 0}
            </span>
          </div>
          <button
            onClick={() => {
              var t = JSON.parse(JSON.stringify(issueComments));
              var newArr = [];
              newArr.push({
                comment: "",
                commentBy: JSON.parse(localStorage.getItem("user"))._id,
                commentByName: JSON.parse(localStorage.getItem("user")).fullName
              });
              t.map((eachOld) => newArr.push(eachOld));
              setIssueComments(newArr);
            }}
            style={{ backgroundColor: "rgba(255,255,255,0.15)", color: "#fff", border: "1.5px solid rgba(255,255,255,0.35)", borderRadius: 7, padding: "0.32rem 0.9rem", fontSize: "0.8rem", fontWeight: 600, cursor: "pointer" }}
          >
            + Add
          </button>
        </div>
      </Card.Header>
      <Card.Body style={styles.commentsCardBody}>
        {issueComments &&
          issueComments.map((eachComment, i) => (
            <Comment
              key={eachComment._id || i}
              comment={eachComment}
              popComment={popComment}
              saveComment={saveComment}
              reloadData={props.reloadData}
            />
          ))}
      </Card.Body>
    </Card>
  );
};

export default IssueComments;
